import { createActionCreator, createAsyncActionCreator } from "@gamedev-web/gamedev-sdk-core";

// we use empty string to denote platform's partner id to affect allow listed
// root level reducer
const PlatformActionPartnerId = "";

export const createAction = createActionCreator(PlatformActionPartnerId);
export const createAsyncAction = createAsyncActionCreator(PlatformActionPartnerId);
